import { GenDialogMultiSelectDropdown } from '@pinnacleautomotive/clarity-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUserCompanies } from '../../../redux/selectors/userDataSelectors';

const DealersFilter = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  const companies = useSelector(selectUserCompanies)?.sort((a, b) =>
    a?.name.localeCompare(b?.name)
  );

  const handleSelectedDealers = selectedDealers => {
    setSelectedFilters(state => ({
      ...state,
      selectedDealers: {
        dealers: selectedDealers.map(c => c.companyId),
        allSelected: selectedDealers.length === companies.length,
      },
    }));
  };

  return (
    <GenDialogMultiSelectDropdown
      options={companies}
      selectedOptions={selectedFilters.selectedDealers.dealers}
      title={t('dealers')}
      placeholderText="Search dealers..."
      enableSelectAll={true}
      entity="Dealer"
      optionIdKey="companyId"
      optionLabelKey="name"
      onChange={handleSelectedDealers}
    />
  );
};

export default DealersFilter;
